module.exports = __webpack_public_path__ + "img/flow_chart.36bcc96e.png";